import { createFileRoute } from "@tanstack/react-router";
import StoryExperience from "@/components/StoryExperience";

const URL = "https://www.travelbackland.com/luxury-corporate-retreats";
const TITLE = "Luxury Corporate Retreats in Arizona — Team Offsites | Backland";
const DESC =
  "Run an inspired team offsite at Backland: private luxury nature resort, focused meeting space, on-site dining, and guided experiences across 160 acres of Northern Arizona ponderosa pine forest.";
const OG_IMAGE =
  "/__l5e/assets-v1/5a8c904d-9fd4-4bbf-85ed-2a0f99e4fa33/lounge-interior.jpg";

export const Route = createFileRoute("/luxury-corporate-retreats")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Corporate Retreats at Backland",
          serviceType: "Corporate retreat venue",
          url: URL,
          description: DESC,
          areaServed: { "@type": "State", name: "Arizona" },
          provider: {
            "@type": "LodgingBusiness",
            name: "Backland",
            address: { "@type": "PostalAddress", addressRegion: "AZ", addressCountry: "US" },
          },
        }),
      },
    ],
  }),
  component: CorporateRetreatsRoute,
});

function CorporateRetreatsRoute() {
  return <StoryExperience initialCategorySlug="groups" />;
}
